"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "player-timer" };
const _hoisted_2 = { class: "player-timer-hours" };
const _hoisted_3 = { class: "player-timer-minutes" };
const _hoisted_4 = { class: "player-timer-seconds" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (_ctx.hasHours())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                (0, vue_1.createElementVNode)("div", _hoisted_2, (0, vue_1.toDisplayString)(_ctx.getHours()), 1),
                _cache[0] || (_cache[0] = (0, vue_1.createElementVNode)("div", { class: "timer-delimiter" }, ":", -1))
            ], 64))
            : (0, vue_1.createCommentVNode)("", true),
        (0, vue_1.createElementVNode)("div", _hoisted_3, (0, vue_1.toDisplayString)(_ctx.getMinutes()), 1),
        _cache[1] || (_cache[1] = (0, vue_1.createElementVNode)("div", { class: "timer-delimiter" }, ":", -1)),
        (0, vue_1.createElementVNode)("div", _hoisted_4, (0, vue_1.toDisplayString)(_ctx.getSeconds()), 1)
    ]));
}
